import { useEffect, useState } from 'react';

const usePending = (isPending: boolean, defaultPending = true) => {
  const [isLocalPending, setLocalPending] = useState(defaultPending);

  useEffect(() => {
    setLocalPending(isPending);
  }, [isPending]);

  return isLocalPending;
};

export default usePending;
